import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../firebase';
import { sendEmailVerification } from 'firebase/auth';

export default function VerifyEmail() {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        navigate('/');
        return;
      }

      if (user.emailVerified) {
        // Email is verified, proceed to MFA setup
        navigate('/set-up-mfa');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleResendEmail = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        await sendEmailVerification(user);
        setError('Verification email sent! Please check your inbox.');
      }
    } catch (err) {
      console.error("Error sending verification email:", err);
      setError("Failed to send verification email. Please try again.");
    }
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-1/2 flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-sm">
          <img src="/td_logo_full_2025.png" alt="Logo" className="mx-auto mb-10" style={{ width: '250px', height: 'auto' }} />
          <h2 className="text-3xl font-bold mb-2 text-center">
            Verify your email
          </h2>
          <p className="text-gray-600 mb-10 text-center">
            We've sent a verification email to your inbox. Please verify your email to continue.
          </p>
          
          <button
            onClick={handleResendEmail}
            className="w-full font-bold bg-violet-900 text-white py-2 rounded-lg hover:bg-violet-800 transition duration-100 mb-4"
          >
            Resend verification email
          </button>
          
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 text-sm rounded-lg relative" role="alert">
              <span className="block sm:inline">{error}</span>
            </div>
          )}
        </div>
      </div>
      <div className="w-1/2 bg-gray-200"></div>
    </div>
  );
}